import {
    Component,
    Input,
    ChangeDetectorRef,
    Output,
    EventEmitter,
    HostListener,
} from '@angular/core';

import { ActionModalSize } from './action-modal.enum';
import { ActionModal, ActionModalButton } from './action-modal.interface';

@Component({
    selector: 'mapp-action-modal',
    templateUrl: './action-modal.component.html',
    styleUrls: ['./action-modal.component.scss'],
    standalone: false,
})
export class ActionModalComponent implements ActionModal {
    @Input() iconPath?: string;

    @Input() modalClass?: string;

    @Input() title: string;

    @Input() description?: string;

    @Input() primaryButton?: ActionModalButton;

    @Input() secondaryButton?: ActionModalButton;

    @Input() secondaryNoButton?: ActionModalButton;

    @Input() size: ActionModalSize = ActionModalSize.Default;

    @Input() hideCloseButton: boolean;

    @Output() closeModal?: EventEmitter<void> = new EventEmitter<void>();

    isVisible: boolean;

    disabled = false; // Add the 'disabled' property with a default value

    /**
     *
     * @param cdr
     */
    constructor(private cdr: ChangeDetectorRef) {}

    private static BACKDROP_SELECTOR = '.aida-modal-backdrop';

    /**
     *
     */
    open(): void {
        // ensure a single shared backdrop is present at body level to block background interactions
        if (typeof document !== 'undefined') {
            let backdrop = document.body.querySelector(
                ActionModalComponent.BACKDROP_SELECTOR
            ) as HTMLElement | null;
            if (!backdrop) {
                backdrop = document.createElement('div');
                backdrop.className = ActionModalComponent.BACKDROP_SELECTOR.replace('.', '');
                Object.assign(backdrop.style, {
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    background: 'transparent',
                    zIndex: '200100',
                    pointerEvents: 'auto',
                } as any);
                document.body.appendChild(backdrop);
            }
        }

        this.isVisible = true;
        this.cdr.detectChanges();
    }

    /**
     *
     */
    close(): void {
        this.isVisible = false;
        if (typeof document !== 'undefined') {
            const backdrop = document.body.querySelector(
                ActionModalComponent.BACKDROP_SELECTOR
            ) as HTMLElement | null;
            if (backdrop && backdrop.parentElement) {
                backdrop.parentElement.removeChild(backdrop);
            }
        }
        this.cdr.detectChanges();
    }

    /**
     *
     */
    onCloseButtonClick(): void {
        this.closeModal.emit();
        this.close();
    }

    /**
     * Close visible modal on Escape key for keyboard accessibility.
     * @param event
     */
    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey(event: Event): void {
        if (!this.isVisible) {
            return;
        }

        event.preventDefault();
        this.onCloseButtonClick();
    }
}
